import { Box, Typography } from "@mui/material/";
import './index.scss';


interface IEmptyContentProps {
    contentType: string
    icon: JSX.Element
}
export const EmptyContent: React.FC<IEmptyContentProps> = ({
    contentType,
    icon,
    ...props
}) => {



    return (
        <Box className="dashboard-widget-empty-content">
            <Typography variant="h1" color="primary">
                {icon}

            </Typography>

            <Typography variant="body2" color="GrayText" >No {contentType}</Typography>

        </Box>


    );

}